import { render, staticRenderFns } from "./TransactionLimits.vue?vue&type=template&id=15a9bc87&"
import script from "./TransactionLimits.vue?vue&type=script&lang=ts&"
export * from "./TransactionLimits.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports